/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PowerMeterSnapshot } from "./PowerMeterSnapshot";
import {
    PowerMeterSnapshotFromJSON,
    PowerMeterSnapshotFromJSONTyped,
    PowerMeterSnapshotToJSON,
} from "./PowerMeterSnapshot";
import type { DistributionBoardSnapshot } from "./DistributionBoardSnapshot";
import {
    DistributionBoardSnapshotFromJSON,
    DistributionBoardSnapshotFromJSONTyped,
    DistributionBoardSnapshotToJSON,
} from "./DistributionBoardSnapshot";
import type { ChargerSnapshot } from "./ChargerSnapshot";
import {
    ChargerSnapshotFromJSON,
    ChargerSnapshotFromJSONTyped,
    ChargerSnapshotToJSON,
} from "./ChargerSnapshot";

/**
 * Objects of type CoreSnapshotMessage are sent to hub method named coreSnapshotMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('coreSnapshotMessage', (message: CoreSnapshotMessage) => {}`
 * @export
 * @interface CoreSnapshotMessage
 */
export interface CoreSnapshotMessage {
    /**
     *
     * @type {Array<DistributionBoardSnapshot>}
     * @memberof CoreSnapshotMessage
     */
    distributionBoardSnapshots?: Array<DistributionBoardSnapshot>;
    /**
     *
     * @type {Array<PowerMeterSnapshot>}
     * @memberof CoreSnapshotMessage
     */
    powerMeterSnapshots?: Array<PowerMeterSnapshot>;
    /**
     *
     * @type {Array<ChargerSnapshot>}
     * @memberof CoreSnapshotMessage
     */
    chargerSnapshots?: Array<ChargerSnapshot>;
    /**
     *
     * @type {string}
     * @memberof CoreSnapshotMessage
     */
    deviceType?: CoreSnapshotMessageDeviceTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CoreSnapshotMessage
     */
    deviceId?: string;
}

/**
 * @export
 */
export const CoreSnapshotMessageDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type CoreSnapshotMessageDeviceTypeEnum =
    (typeof CoreSnapshotMessageDeviceTypeEnum)[keyof typeof CoreSnapshotMessageDeviceTypeEnum];

/**
 * Check if a given object implements the CoreSnapshotMessage interface.
 */
export function instanceOfCoreSnapshotMessage(
    value: object,
): value is CoreSnapshotMessage {
    return true;
}

export function CoreSnapshotMessageFromJSON(json: any): CoreSnapshotMessage {
    return CoreSnapshotMessageFromJSONTyped(json, false);
}

export function CoreSnapshotMessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CoreSnapshotMessage {
    if (json == null) {
        return json;
    }
    return {
        distributionBoardSnapshots:
            json["distributionBoardSnapshots"] == null
                ? undefined
                : (json["distributionBoardSnapshots"] as Array<any>).map(
                      DistributionBoardSnapshotFromJSON,
                  ),
        powerMeterSnapshots:
            json["powerMeterSnapshots"] == null
                ? undefined
                : (json["powerMeterSnapshots"] as Array<any>).map(
                      PowerMeterSnapshotFromJSON,
                  ),
        chargerSnapshots:
            json["chargerSnapshots"] == null
                ? undefined
                : (json["chargerSnapshots"] as Array<any>).map(
                      ChargerSnapshotFromJSON,
                  ),
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
    };
}

export function CoreSnapshotMessageToJSON(
    value?: CoreSnapshotMessage | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        distributionBoardSnapshots:
            value["distributionBoardSnapshots"] == null
                ? undefined
                : (value["distributionBoardSnapshots"] as Array<any>).map(
                      DistributionBoardSnapshotToJSON,
                  ),
        powerMeterSnapshots:
            value["powerMeterSnapshots"] == null
                ? undefined
                : (value["powerMeterSnapshots"] as Array<any>).map(
                      PowerMeterSnapshotToJSON,
                  ),
        chargerSnapshots:
            value["chargerSnapshots"] == null
                ? undefined
                : (value["chargerSnapshots"] as Array<any>).map(
                      ChargerSnapshotToJSON,
                  ),
        deviceType: value["deviceType"],
        deviceId: value["deviceId"],
    };
}
